// extracted by mini-css-extract-plugin
export default {"headerLogo":"form-header_headerLogo__bO37T"};